import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button, Form } from "react-bootstrap";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import { selectToken } from "../auth/auth.selector";
import { fetchApiData } from "../../redux/reducers/commonApiSlice";
import "../../styles/ticket-system/reopen-ticket-modal.css";
import { fetchInHouseUsersData } from "../../redux/reducers/dropdownApiSlice";
import SelectDropdownLabel from "../components-react/SelectDropdownLabel";

const HandoverTicketModal = ({
  isOpen,
  onClose,
  ticket,
  onSubmit,
  handleReload,
  userInfoData,
}) => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);

  const { inhouseUsers } = useSelector((state) => state.dropdown);

  //   console.log("ticket", ticket);
  //   console.log("ticket", ticket?.gym_id);

  useEffect(() => {
    if (ticket?.gym_id) {
      dispatch(
        fetchInHouseUsersData({
          token: token,
          qps: `account_type=receptionist,trainer&gym_id=${ticket?.gym_id}&status=active`,
          pageNo: 1,
          limit: 100,
        })
      );
    }
  }, [ticket?.gym_id, dispatch, token]);

  //   console.log("inhouseUsers", inhouseUsers);

  // Form state
  const [selectedReceptionist, setSelectedReceptionist] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  // Validation function
  const validateForm = () => {
    const errors = {};

    if (!selectedReceptionist) {
      errors.selectedReceptionist = "Please select a receptionist";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async () => {
    if (!validateForm()) {
      toast.error("Please select a receptionist to handover the ticket");
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        ticket_id: ticket?.uid,
        new_owner_id: selectedReceptionist?.value,
      };

      const result = await dispatch(
        fetchApiData({
          method: "POST",
          endpoint: "/ticketSystem/handover",
          payload: payload,
          token: token,
        })
      );

      //   console.log("result", result);

      if (result?.payload?.status) {
        toast.success(
          result.payload.message || "Ticket ownership handed over successfully!"
        );
        resetForm();
        onClose();
        // if (handleReload) {
        //   handleReload();
        // }
        if (onSubmit) {
          onSubmit();
        }
      } else {
        toast.error(result?.payload?.message || "Failed to handover ticket");
      }
    } catch (error) {
      console.error("Error handing over ticket:", error);
      toast.error("An error occurred while handing over ticket");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Reset form
  const resetForm = () => {
    setSelectedReceptionist("");
    setFormErrors({});
  };

  // Handle modal close
  const handleClose = () => {
    resetForm();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel="Handover Ticket Ownership"
      ariaHideApp={false}
      closeTimeoutMS={300}
    >
      <div className="reopen-ticket-container">
        <div style={{ padding: "10px" }}>
          <ModalHeadAndClose
            title={`Handover Ticket Ownership - ${ticket?.ticket_no || ""}`}
            subtitle={`${ticket?.gym_name || "WTF Gym"} - ${
              ticket?.issue_type_name || ""
            } - ${ticket?.category_name || ""}`}
            onClose={handleClose}
          />
        </div>

        <div className="modal-body-content">
          {/* Current Ticket Owner Info */}
          <div className="form-section">
            <label className="section-label">CURRENT TICKET OWNER</label>
            <div className="current-owner-info">
              <p
                style={{
                  padding: "10px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "6px",
                  margin: "0",
                  fontSize: "14px",
                }}
              >
                <strong>Note:</strong> The current ticket owner (
                {ticket?.created_by_name || "Unknown"}) appears to be deleted
                from the system. Please select a new receptionist to take
                ownership of this ticket.
              </p>
            </div>
          </div>

          {/* Receptionist Selection */}
          <div className="form-section">
            <label className="section-label required">
              SELECT NEW RECEPTIONIST/TRAINER
            </label>
            <SelectDropdownLabel
              options={inhouseUsers?.length > 0 ? inhouseUsers : []}
              value={selectedReceptionist}
              setSelectedOption={(selectedValue) =>
                setSelectedReceptionist(selectedValue)
              }
              name="Select receptionist/trainer"
            />
            {formErrors.selectedReceptionist && (
              <span className="error-message">
                {formErrors.selectedReceptionist}
              </span>
            )}
          </div>

          {/* Action Buttons */}
          <div className="modal-actions">
            <Button
              variant="outline-secondary"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
            <Button
              variant="success"
              onClick={handleSubmit}
              disabled={isSubmitting || !selectedReceptionist}
              className="handover-btn"
            >
              {isSubmitting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  Handing Over...
                </>
              ) : (
                "Handover Ticket"
              )}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default HandoverTicketModal;
